module.exports = __webpack_public_path__ + "static/media/b19.6da1e3b8.png";